import PostEntry, { PostEntrySkeleton } from './PostEntry';
import type { PostEntryProps } from '../types';

export default function PostsGrid({
  posts,
  image,
  excerpt,
  social,
  meta,
}: {
  posts: PostEntryProps[];
  image?: boolean;
  excerpt?: boolean;
  social?: boolean;
  meta?: boolean;
}) {
  return (
    <div className="posts-grid">
      <ul className="posts-grid__inner">
        {posts.map((post, i) => {
          if (!post) {
            return null;
          }
          return (
            <li className="posts-grid__item" key={`${post.title}-${i}`}>
              <PostEntry
                post={post}
                image={image}
                excerpt={excerpt}
                social={social}
                meta={meta}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export function PostsGridSkeleton({
  count,
  image,
  excerpt,
  social,
  meta,
}: {
  count: number;
  image?: boolean;
  excerpt?: boolean;
  social?: boolean;
  meta?: boolean;
}) {
  return (
    <div className="posts-grid">
      <ul className="posts-grid__inner">
        {Array.from({ length: count }).map((_, i) => (
          <li className="posts-grid__item" key={`post-skeleton-${i}`}>
            <PostEntrySkeleton
              image={image}
              excerpt={excerpt}
              social={social}
              meta={meta}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
